<app-vip-discounts-partners></app-vip-discounts-partners>
<div class="checkbox-btns-container d-flex align-items-center gap-4 mb-4">
  <mat-checkbox
    class="easy-checkbox"
    (change)="$event ? productTableSource.toggleAllRows() : null"
    [checked]="
      productTableSource.selection.hasValue() &&
      productTableSource.isAllSelected()
    "
    [indeterminate]="
      productTableSource.selection.hasValue() &&
      !productTableSource.isAllSelected()
    "
    [aria-label]="checkboxLabel()"
    [disabled]="!productTableSource.data.length"
  >
  </mat-checkbox>
  <div class="selection-container me-4">
    {{
      productTableSource.selection.selected.length +
        ("SHARED.PIECES" | translate)
    }}
    {{ "SHARED.SELECTED" | translate }}
  </div>
  <button
    class="me-4"
    mat-stroked-button
    color="primary"
    [disabled]="isProductSelected && (isPartnerSelected$ | async) ? null : true"
    type="button"
    (click)="addDiscount()"
  >
    {{ "VIP_DISCOUNTS.ADD_DISCOUNT_BTN" | translate }}
  </button>
</div>
<div class="table-container">
  <table
    class="data-table"
    mat-table
    [dataSource]="productTableSource"
    matSort
    #sortimentTable
  >
    <app-checkable-column
      [hideCheckboxInHeader]="true"
      [tableRef]="sortimentTable"
    >
    </app-checkable-column>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "PRODUCTS.TITLE.BRAND" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.brand }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-3">
        {{ "PRODUCTS.TITLE.NAME" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="px-3">
        <a
          [routerLink]="'/selling/prices/discounts/vip-discounts/product-view'"
          [queryParams]="{ id: element.packagingUnitId }"
        >
          {{ element.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "PRODUCTS.TITLE.AMOUNT_WITH_UNIT" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="px-3">
        <div class="flex right gap-2">
          <span>{{ element.amount }}</span>
          <span class="unit">{{
            "PRODUCTS.UNIT." + element.unit | translate
          }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="hasCollectionPackaging">
      <th mat-header-cell *matHeaderCellDef class="px-3">
        {{ "PRODUCTS.TITLE.COLLECTION_UNIT" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="px-3">
        {{
          element.collectionPackagings
            ? ("PACKAGING.PACKAGING." +
                element.collectionPackagings
                  .at(-1)
                  .parentPackingMethodSubType.toUpperCase() | translate)
            : "-"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ean">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "PRODUCTS.TITLE.EAN" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <p *ngFor="let ean of element.eanCodes" class="my-1">{{ ean }}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="priced">
      <th mat-header-cell *matHeaderCellDef class="px-3">
        {{ "PRODUCTS.TITLE.PRICE" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="price-container px-3">
        <a
          *ngIf="element.priced; else noPrice"
          [routerLink]="
            '/selling/prices/discounts/vip-discounts/selected-products'
          "
          [queryParams]="{ s: element.productSortimentId }"
          >{{ "PRODUCTS.MODAL.PRICED" | translate }}</a
        >
        <ng-template #noPrice>-</ng-template>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="productTableSource.displayedColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="
        let row;
        let idx = index;
        columns: productTableSource.displayedColumns
      "
    ></tr>
  </table>
</div>

<div *ngIf="productTableSource.isLoading | async">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-paginator
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="(totalProducts | async) ?? 0"
  showFirstLastButtons
>
</mat-paginator>
